module.exports = __webpack_public_path__ + "static/img/his-Asset 80.a884689.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/his-Asset 80.png
// module id = 3dkw
// module chunks = 2